import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20masculine%20aesthetic%20photography%20with%20vintage%20leather%20tool%20roll%20displaying%20premium%20hand%20tools%2C%20mechanical%20watch%2C%20and%20EDC%20gear%20on%20rich%20walnut%20wood%20table%2C%20dramatic%20warm%20side%20lighting%20from%20single%20source%20creating%20deep%20shadows%2C%20atmospheric%20smoke%20effect%20in%20the%20air%2C%20dark%20moody%20background%20with%20subtle%20leather%20and%20metal%20textures%2C%20cinematic%20masculine%20product%20photography&width=1800&height=900&seq=hero-main-2024&orientation=landscape"
        alt="男子汉宝藏 - 硬核好物精选"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="男子汉宝藏 - 精选男士品质好物"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-shield-star-line text-primary-400 text-sm"></i>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">真男人必备的硬核好物聚集地</span>
        </div>
        <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 mb-5 leading-tight">
          男子汉宝藏
        </h1>
        <p className="text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚真正值得男人拥有的精品好物、生活方式与硬核装备推荐。
          从工具装备到品质生活，每一件都经过严苛筛选，帮你找到属于男人的宝藏级单品。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hardcore-gear"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors"
          >
            <i className="ri-compass-3-line"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg border border-background-50/30 transition-colors"
          >
            <i className="ri-information-line"></i>
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}